import React from 'react';
import { Smartphone, Lock, ShieldCheck } from 'lucide-react';
interface CTABlockProps {
  href?: string;
  children: React.ReactNode;
  className?: string;
  onClick?: () => void;
  hideBullets?: boolean;
}
// Add type for fbq
declare global {
  interface Window {
    fbq: any;
  }
}
export function CTABlock({
  href = '#cart',
  children,
  className = '',
  onClick,
  hideBullets = false
}: CTABlockProps) {
  const handleClick = () => {
    if (typeof window !== 'undefined' && window.fbq) {
      window.fbq('track', 'InitiateCheckout');
    }
    if (onClick) onClick();
  };
  return <div className="inline-flex flex-col items-center gap-4 w-full" data-id="element-15">
      <a href={href} onClick={handleClick} className={`inline-block bg-gold-500 hover:bg-gold-400 text-forest-900 font-bold py-4 px-8 rounded-full text-center transition-colors animate-pulse-gold shadow-lg ${className}`} data-id="element-16">
        {children}
      </a>
      {!hideBullets && <div className="flex items-center justify-center gap-2 md:gap-4 text-xs md:text-sm font-medium opacity-90 flex-wrap" data-id="element-17">
          <span className="flex items-center gap-1.5" data-id="element-18">
            <Smartphone className="w-3.5 h-3.5 text-gold-400" data-id="element-19" />
            Acceso inmediato
          </span>
          <span className="hidden md:inline text-current opacity-40" data-id="element-20">|</span>
          <span className="flex items-center gap-1.5" data-id="element-21">
            <Lock className="w-3.5 h-3.5 text-gold-400" data-id="element-22" />
            Pago seguro en ARS
          </span>
          <span className="hidden md:inline text-current opacity-40" data-id="element-23">|</span>
          <span className="flex items-center gap-1.5" data-id="element-24">
            <ShieldCheck className="w-3.5 h-3.5 text-gold-400" data-id="element-25" />
            Garantía 7 días
          </span>
        </div>}
    </div>;
}